import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import PageTransitionWrapper from '../components/Transition';


function Layout() {
  const location = useLocation();
  
  // Check if we're on specific pages 
  const isLoginPage = location.pathname === '/login'; 
  const isSignupPage = location.pathname === '/signup';
  const isAiPage = location.pathname === '/mysidekick';  

  return (
    <div className="min-h-screen flex flex-col bg-customColor1 text-white">
      {!isLoginPage && !isSignupPage && !isAiPage && <Navigation />}
      <main id="content" className="flex-grow">
      <PageTransitionWrapper> 
        <div className="pl-16 pt-5 pb-5 pr-16">
          <Outlet />
        </div>
        </PageTransitionWrapper>
      </main>
      {!isLoginPage && !isSignupPage && !isAiPage && <Footer />}
    </div>
  );
}

export default Layout;